import { connect } from 'react-redux';
import EditLocalUser from '../../components/user_authentication/EditLocalUser';
import { updateModalData } from '../../actions/user_authentication';

const mapStateToProps = state => ({
  user: {
    ...state.userAuthentication.modal.data,
    ...state.userAuthentication.modal.changes,
  },
});

const mapDispatchToProps = dispatch => ({
  updateName: e => {
    dispatch(updateModalData('name', e.target.value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditLocalUser);
